const config = {
  apiUrl: process.env.REACT_APP_API_URL,
  version: process.env.REACT_APP_VERSION_NUMBER,
  talkJsAppId: process.env.REACT_APP_TALK_JS_APP_ID,
}

export default config
